import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import SEO from "@/components/SEO";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/login", { email, password });
      // Il cookie di sessione httpOnly è ora impostato dal backend.
      toast.success("Accesso effettuato");
      nav("/admin/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-risco-bg flex flex-col items-center justify-center p-6" data-testid="admin-login-page">
      <SEO
        title="Area riservata | Ri.Sco. s.r.l."
        description="Accesso riservato al pannello di amministrazione Ri.Sco. s.r.l."
        path="/admin"
        noindex
      />
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <img src="/logo-risco.png" alt="Ri.Sco. s.r.l." style={{ height: '80px', width: 'auto' }} />
        </div>
        <form onSubmit={submit} className="risco-card p-8 space-y-5" data-testid="admin-login-form">
          <div>
            <div className="overline mb-2">Accedi</div>
            <h1 className="font-heading text-2xl text-risco-ink">Pannello di amministrazione</h1>
          </div>
          <div>
            <label className="text-sm text-stone-700">Email</label>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" id="admin-login-email" name="admin-login-email" className="mt-1 w-full bg-white border border-stone-300 rounded-md px-3 py-3 text-risco-ink focus:border-risco-accent outline-none" />
          </div>
          <div>
            <label className="text-sm text-stone-700">Password</label>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" id="admin-login-password" name="admin-login-password" className="mt-1 w-full bg-white border border-stone-300 rounded-md px-3 py-3 text-risco-ink focus:border-risco-accent outline-none" />
          </div>
          <button type="submit" disabled={loading} data-testid="admin-submit" className="w-full inline-flex items-center justify-center gap-2 py-3 rounded-md bg-risco-accent hover:bg-risco-accent-dark disabled:opacity-50 text-white font-semibold">
            <LogIn className="w-4 h-4" /> {loading ? "Accesso..." : "Accedi"}
          </button>
        </form>
        <a href="/" className="block text-center text-stone-500 hover:text-risco-accent text-sm mt-6" data-testid="admin-back-to-site">← Torna al sito</a>
      </div>
    </div>
  );
}
